import { render, staticRenderFns } from "./AboutPage.vue?vue&type=template&id=38def4f2&scoped=true&"
import script from "./AboutPage.vue?vue&type=script&lang=js&"
export * from "./AboutPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38def4f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38def4f2')) {
      api.createRecord('38def4f2', component.options)
    } else {
      api.reload('38def4f2', component.options)
    }
    module.hot.accept("./AboutPage.vue?vue&type=template&id=38def4f2&scoped=true&", function () {
      api.rerender('38def4f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AboutPage.vue"
export default component.exports